import * as React from "react";
import { forwardRef } from "react";
const SvgCheckboxActive = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={15} height={15} viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<defs><path id="bf9k9cj5la" d="m3 7.463.994-.982 2.131 2.113L10.756 4l.994.987-5.625 5.575z" /></defs><g fill="none" fillRule="evenodd"><rect stroke="#5ACCE6" fill="#5ACCE6" x={0.5} y={0.5} width={14} height={14} rx={3} /><use fill="#000" xlinkHref="#bf9k9cj5la" /></g></svg>;
const ForwardRef = forwardRef(SvgCheckboxActive);
export { ForwardRef as ReactComponent };